<script setup>
import { onMounted } from 'vue'
import { RouterView } from 'vue-router'
import { NFlex, NGradientText, NButton } from 'naive-ui'
import { useAuth, authMethod } from '@/auth'
import AppLayout from './components/AppLayout.vue'
import AppProvider from './components/AppProvider.vue'
import LocalLogin from './components/LocalLogin.vue'

const auth = useAuth()
const user = auth.getUser()

onMounted(async () => {
  // This is for the MSAL redirect flow. It will be a no-op for local auth.
  await auth.handleRedirect()
})
</script>

<template>
  <AppProvider>
    <AppLayout :loggedIn="user.isLoggedIn">
      <RouterView v-if="user.isLoggedIn" />
      <div v-else>
        <LocalLogin v-if="authMethod === 'local'" :login="auth.login" />
        <n-flex v-else justify="center" align="center" vertical>
          <p class="login-desc">
            Please sign in with your
            <n-gradient-text type="info"> Sequins.bio </n-gradient-text>
            account to continue.
          </p>
          <n-button class="login-button" type="primary" @click="auth.login()">
            Sign in with Sequins
          </n-button>
        </n-flex>
      </div>
    </AppLayout>
  </AppProvider>
</template>

<style scoped>
.login-desc {
  margin: 20px 0;
}
</style>
